import React from "react";
import PropTypes from "prop-types";
import TopMessage from "../components/TopMessage";
import Backdrop from "@mui/material/Backdrop";

export default function PlatformScoutGuidanceStep({ isLiveDemo, showOverlay }) {

    if (!isLiveDemo) return null;

    return (
        <>
            {/* 🌑 Global Backdrop */}
            <Backdrop
                sx={{ color: '#fff', zIndex: 1200 }} // Below raised elements (1250)
                open={showOverlay}
            />

            <TopMessage
                visible={showOverlay}
                title="Welcome to Platform Scout!"
                subtitle="You can use this page to search competitors."
            />
        </>
    );
}

PlatformScoutGuidanceStep.propTypes = {
    isLiveDemo: PropTypes.bool,
};
